import { ReactNode } from 'react';
import { FreeMonthRequestOutcome } from 'src/app/services/freeMonthSignup';
import { renderBracketLinks } from 'src/pages/invoiceSignupLinks';

/** Existing service address used elsewhere in the app (accountReady). */
export const FREE_MONTH_CONTACT_URL = 'mailto:info@anonify.nl';

/** Shared by /start and the demo pop-up: one string per request outcome. */
export const MESSAGE_KEY: Partial<Record<FreeMonthRequestOutcome, string>> = {
  free_mail: 'startFreeMonth.freeMail',
  cap_reached: 'startFreeMonth.capReached',
  // The request form is limited per IP per 24 hours; check/confirm keep 'an hour'.
  rate_limited: 'startFreeMonth.rateLimitedRequest',
  invalid: 'invoiceSignup.error.invalid',
  turnstile: 'invoiceSignup.error.turnstile',
  error: 'invoiceSignup.error.generic',
};

/** The free-mail text carries a bracketed link label to the service address. */
export const renderFreeMonthMessage = (messageKey: string, text: string): ReactNode =>
  messageKey === 'startFreeMonth.freeMail' ? renderBracketLinks(text, [FREE_MONTH_CONTACT_URL]) : text;
